import React from 'react';
import Toggle from 'components/controls/toggle'

const FeatureSelector = props => {
    const {
        featureList,
        toggleCallback,
        featureState,
        canSelect
    } = props

    return (
        <ul className="feature-list">
            {featureList.map((feature, index) => {
                const isActive = featureState[feature.key] && canSelect

                return (
                    <li className={isActive ? 'active' : null} key={index} onClick={_ => {
                        toggleCallback(feature)
                    }}>
                        <h3>
                            {feature.title}
                        </h3>
                        <span>
                            {feature.body}
                        </span>
                        <Toggle
                            toggleState={isActive}
                            toggleChangeCallback={_ => { }}
                            hideLabels={true}
                            greyWhenUnselected={true}
                            toggleOptions={[
                                {
                                    name: 'On'
                                }, {
                                    name: 'Off'
                                }
                            ]}
                        />
                    </li>
                )
            })}
        </ul>
    )
};

export default FeatureSelector;
